module.exports = __webpack_public_path__ + "img/Negado.36f84980.png";